import axios from 'axios';
import Cookies from 'js-cookie';

// Create an Axios instance with default settings
const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/admin`, // Base API URL from environment variable
    timeout: 10000, // Set timeout for requests
});

// Interceptor to attach token and signature dynamically
api.interceptors.request.use(
    config => {
        const token = Cookies.get('__token'); // Retrieve token from cookies
        const signature = process.env.REACT_APP_API_SIGNATURE; // Get API signature

        // Attach Authorization token if available
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        // Attach API signature if available
        if (signature) {
            config.headers['Signature'] = signature;
        }

        // Dynamically set the Content-Type
        if (config.data instanceof FormData) {
            // If request contains files, use multipart/form-data
            config.headers['Content-Type'] = 'multipart/form-data';
        } else {
            // Default for JSON requests
            config.headers['Content-Type'] = 'application/json';
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle errors globally
api.interceptors.response.use(
    response => {
        return response.data;
    },
    error => {
        if (error.response) {
            if (error.response.status === 401) {
                // SEC-11: an expired or revoked session signs the panel out instead of leaving
                // a half-working screen. The login calls themselves are left alone (a wrong
                // code must not reload the login page and lose what was typed).
                const url = String(error.config?.url || '');
                const isLoginCall = url.includes('/auth/send-otp') || url.includes('/auth/verify-otp');
                if (!isLoginCall && Cookies.get('__token')) {
                    Cookies.remove('__token', { path: '/' });
                    if (window.location.pathname !== '/login') {
                        window.location.assign('/login?expired=1');
                    }
                }
            } else {
                console.log(`API Error: ${error.response.status} - ${error.response.data.message || error.message}`);
            }
        } else {
            console.log("Network error or no response from server.");
        }
        // Return the error to the caller
        return Promise.reject(error);
    }
);

export default api;
